/**
 * Shared constants for the lottery "flag suspicious ticket" workflow.
 * Imported by both OperatorTicketsList.js (flag UI) and
 * AdminFlaggedTicketsTab.js (review queue) so reason labels can never drift
 * between operator-facing and admin-facing screens.
 *
 * Keys MUST match the FLAG_REASONS set in /app/backend/routes/operator_lottery.py.
 */
export const FLAG_REASON_LABELS = {
    suspicious_scan:     'Suspicious scan (photo doctored / unclear)',
    low_ocr_confidence:  'Low OCR confidence — verify numbers',
    disputed_by_player:  'Player disputes this ticket',
    wrong_amount:        'Wrong amount entered',
    other:               'Other (see note)',
};

// Short forms for tight UI spaces (e.g. table badges)
export const FLAG_REASON_SHORT = {
    suspicious_scan:    'Suspicious scan',
    low_ocr_confidence: 'Low OCR confidence',
    disputed_by_player: 'Disputed by player',
    wrong_amount:       'Wrong amount',
    other:              'Other',
};
